import styled from "styled-components";

export const ListItem = styled.div`
  position: relative;
`;

export const Applicant = styled.h2`
  font-size: 16px;
  color: #333333;
  line-height: 24px;
  font-weight: 400;
  margin-top: 0;
  margin-bottom: 0.5em;
  width: calc(100% - 65px);
`;

export const ApprovalNumber = styled.div``;

export const NumberBox = styled.div`
  background-color: #f2f6ff;
  border-radius: 4px;
  opacity: 0.5;
  padding: 12px 12px 0 12px;
  display: flex;
  flex-direction: column;
`;

export const NumberBoxInner = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
`;
export const NumberBoxInnerTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 12px;
  color: #45629d;
`;
export const NumberBoxInnerText = styled.div`
  flex: 1;
  display: flex;
  font-weight: 400;
  font-size: 12px;
  color: #45629d;
  line-height: 18px;
  word-break: break-all;
`;
export const NumberBoxInnerImage = styled.img`
  width: 14px;
  height: 14px;
`;

export const StatusTag = styled.div`
  min-height: 24px;
  background-color: rgba(255, 118, 0, 0.1);
  position: absolute;
  right: -14px;
  top: -13px;
  border-radius: 0 4px 0 12px;
  text-align: center;
  padding: 0 10px;
  /* width: 64px; */
`;
